import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  CanLoad,
  Route,
  Router,
  RouterStateSnapshot,
  UrlSegment,
  UrlTree
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { debounceTime, map, mergeMap } from 'rxjs/operators';

import { LoginService, AccountService } from 'app/shared';



@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanLoad, CanActivate, CanActivateChild {
  constructor(
    private router: Router,
    private accountService: AccountService,
    private loginService: LoginService
  ) {
  }

  canLoad(route: Route, segments: UrlSegment[]): Observable<boolean | UrlTree> {
    return this.accountService.identity().pipe(
      debounceTime(1000),
      map((account) => {
        if (!!account) {
          return true;
        }
        return this.router.createUrlTree(['/auth', 'sign-in']);
      })
    );
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this.allow(route);
  }

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this.allow(childRoute);
  }

  private allow(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    return this.accountService.identity().pipe(
      debounceTime(1000),
      mergeMap((account) => {
        if (!account) {
          return of(this.router.createUrlTree(['/auth', 'sign-in']));
        }
        if (!account.roles.length) {
          return this.loginService.logout()
            .pipe(
              map(() => {
                this.router.navigate(['/auth', 'deactivated'], {
                  state: account
                });
                return false;
              })
            );
        }
        return of(true);
      })
    );
  }
}
